import { Component, inject, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../../core/notifications/notification.service';
import { DeadlineAlert } from '../../../core/notifications/deadline-alert.model';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.html',
  styleUrl: './notification-bell.css',
})
export class NotificationBellComponent {
  protected readonly notifications = inject(NotificationService);
  private readonly router = inject(Router);
  private readonly el = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  protected handleDocumentClick(event: MouseEvent): void {
    if (this.notifications.panelOpen() && !this.el.nativeElement.contains(event.target)) {
      this.notifications.closePanel();
    }
  }

  protected togglePanel(): void {
    this.notifications.togglePanel();
  }

  protected openAlert(alert: DeadlineAlert): void {
    this.notifications.closePanel();
    this.router.navigate(alert.link);
  }

  protected dismiss(event: Event, alert: DeadlineAlert): void {
    event.stopPropagation();
    this.notifications.dismiss(alert);
  }

  protected mute(event: Event, alert: DeadlineAlert): void {
    event.stopPropagation();
    this.notifications.mute(alert);
  }

  protected unmute(event: Event, alert: DeadlineAlert): void {
    event.stopPropagation();
    this.notifications.unmute(alert);
  }

  protected urgencyClass(days: number): string {
    if (days <= 7) {
      return 'bg-red-100 text-red-800 border-red-200';
    }
    if (days <= 14) {
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    }
    return 'bg-blue-100 text-blue-800 border-blue-200';
  }
}
